import { createFileRoute } from '@tanstack/react-router'
import { AdminCancellationDashboard } from '@/pages/AdminCancellationDashboard'

export const Route = createFileRoute('/admin-cancellations')({
  component: AdminCancellationDashboard,
})

